/**
 * Controla el diálogo de rechazar tarea.
 */
DialogConfirmarConComentarioCtrl.$inject = ['$log', '$scope', '$http', '$filter'];
export default function DialogConfirmarConComentarioCtrl($log, $scope, $http, $filter) {
    $scope.puedeAnyadirComentario = Sigo.config['comentarios']['estado_modulo'];
    $scope.usuariosParaCitar = [];

    switch ($scope.model.tipo) {
        case "pausar":
            $scope.txt_titulo = $filter('lang')('mensajes.pausar_tarea', 'get');
            $scope.txt_msg = $filter('lang')('mensajes.comentario_pausar_tarea', 'get');
            break;
        case "rechazar":
            $scope.txt_msg = $filter('lang')('mensajes.comentario_rechazar_tarea', 'get');
            $scope.txt_titulo = $filter('lang')('mensajes.rechazar_tarea', 'get');
            break;
        default:
            $scope.txt_msg = $filter('lang')('mensajes.comentario_cambiar_estado_tarea', 'get');
            $scope.txt_titulo = $filter('lang')('mensajes.cambiar_estado_tarea', 'get');
    }

    cargarUsuarios($scope.model.id);

    function cargarUsuarios(tareaId) {
        $log.debug('Cargando usuario implicados en la tarea o incidencia ' + tareaId + '...');
        var url = Sigo.url + '/usuarios/usuariosincidenciaotarea/' + tareaId + '/obras';
        $http.get(url).success(function (data) {
            $log.debug('Usuarios cargados!');
            $scope.usuariosParaCitar = data.usuarios;
        }).error(function (data, status) {
            alert("Ha fallado la petición. Estado HTTP:" + status);
        });
    }

}